import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { utagLinkPDP } from 'features/tealium';
import { Button } from 'components/Button';

import { loadMoreReviews } from '../reducers';

import { reviewPropTypes } from './propTypes';
import ProductReviewCard from './ProductReviewCard';
import './ProductReviewsList.scss';

const ProductReviewsList = ({ reviews, sortText, onClickLoadMore = () => {} }) => {

	const dispatch = useDispatch();
	const { fetchStatus, totalReviews } = useSelector((state) => state.productReviews);
	const showLoadMoreReviews = reviews.length < totalReviews;

	return (
		<div className="ProductReviewsList">
			<div className="ProductReviewList_container">
				{reviews.length > 0
					&& reviews.map((review, index) => (
						<div className="ProductReviewsList__content" key={review.id}>
							<ProductReviewCard review={review} reviewIndex={index + 1} sortText={sortText} />
						</div>
					))}
			</div>
			{showLoadMoreReviews && (
				<div className="ProductReviewsList__button">
					<Button
						buttonStyleVariant="tertiary"
						disabled={fetchStatus === 'pending'}
						onClick={() => {

							dispatch(loadMoreReviews());
							utagLinkPDP('TurnTo')({
								eventAction: 'Ratings-Load-More',
								eventLabel: window.shortSku
							});
							onClickLoadMore();

						}}
					>
						Load More Reviews
					</Button>
				</div>
			)}
		</div>
	);

};

ProductReviewsList.propTypes = {
	reviews: PropTypes.arrayOf(reviewPropTypes),
	onClickLoadMore: PropTypes.func,
	sortText: PropTypes.string
};

export default ProductReviewsList;
